/**
 * This method is primarily used to get short name from
 * Fully Qualified Domain Name which looks something
 * like this "E=bob.joe@abc.com, CN=Bob Joe"
 * which will be converted to "bob.joe@abc.com"
 */
const parseNameFromFullyQualifiedDomainName = (fullyQualifiedDomainName: string): string => {
    if (!fullyQualifiedDomainName) {
        return null;
    }

    const indexStart = fullyQualifiedDomainName.indexOf('=');
    const indexEnd = fullyQualifiedDomainName.indexOf(',');
    if (indexStart >= 0 && indexEnd > indexStart) {
        return fullyQualifiedDomainName.substring(indexStart + 1, indexEnd).trim();
    } else if (indexStart >= 0 && indexEnd < indexStart) {
        return fullyQualifiedDomainName.substring(indexStart + 1).trim();
    }

    return fullyQualifiedDomainName;
};

export default parseNameFromFullyQualifiedDomainName;
